webpackJsonp([26],{

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_user_setting_js__ = __webpack_require__(1167);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e0dc50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_management_vue__ = __webpack_require__(1253);
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_user_setting_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e0dc50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: "https://centralize.maeriminterfood.com",
  baseURLV2: "https://marim-mis-api.maeriminterfood.com"
  // baseURLV2: 'https://marim-api-test.undefined.co.th:4439'
  // baseURLV2: "http://localhost:6100"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1104);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  updateSale: function updateSale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/updatesalesdetails', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  branch: function branch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/branch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteHoldBil: function deleteHoldBil(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/deleteHoldbill', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUser: function roleUser(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUser', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserDelete: function roleUserDelete(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserDelete', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGetCode: function roleUserGetCode(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGetCode', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGet: function roleUserGet(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGet', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserUpdate: function roleUserUpdate(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserUpdate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserInsert: function roleUserInsert(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserInsert', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getRemainStock: function getRemainStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/getRemainStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeStock: function changeStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/changeStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getItemGroup: function getItemGroup(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/dashboard/getItemGroup', null).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(511);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      nowDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      header: {
        'Access-Token': this.$store.state.token
      },
      data_detail: {}
    };
  },

  methods: {
    getConfigCompany: function getConfigCompany() {
      var _this = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].companyDetail(sessionStorage.Url, this.header, function (result) {
        if (result.response === 'success') {
          _this.data_detail = result.data[0];
        } else {
          _this.$notification['success']({
            message: 'ดึงข้อมูลบริษัท',
            description: result.message
          });
        }
        _this.$store.commit('Loading');
      }, function (error) {
        _this.$store.commit('Loading');
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    editConfigCompany: function editConfigCompany() {
      var _this2 = this;

      this.$store.commit('Loading');
      this.data_detail.id = parseInt(this.data_detail.id);
      // this.data_detail.company_id = parseInt(this.data_detail.company_id)
      this.data_detail.tax_rate = parseInt(this.data_detail.tax_rate);
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data_detail));
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].companyUpdate(sessionStorage.Url, this.header, this.data_detail, function (result) {
        if (result.response === 'success') {
          _this2.getConfigCompany();
          _this2.$notification['success']({
            message: 'อัพเดทข้อมูลบริษัทเรียบร้อย'
          });
        } else {
          _this2.$notification['success']({
            message: 'อัพเดทข้อมูลบริษัท',
            description: result.message
          });
        }
        _this2.$store.commit('Loading');
      }, function (error) {
        _this2.$store.commit('Loading');
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    }
  },
  mounted: function mounted() {
    this.getConfigCompany();
  }
});

/***/ }),

/***/ 1130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_settings_company_js__ = __webpack_require__(1117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05448cdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_vue__ = __webpack_require__(1131);
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_settings_company_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05448cdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contianer"},[_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label text-right",attrs:{"for":"ComName"}},[_vm._v("ชื่อบริษัท")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_detail.company_name),expression:"data_detail.company_name"}],staticClass:"form-control",attrs:{"type":"text","id":"ComName","placeholder":"ชื่อบริษัท...."},domProps:{"value":(_vm.data_detail.company_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_detail, "company_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label text-right",attrs:{"for":"TaxID"}},[_vm._v("เลขประจำตัวผู้เสียภาษี")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_detail.tax_id),expression:"data_detail.tax_id"}],staticClass:"form-control",attrs:{"type":"text","id":"TaxID","placeholder":"เลขประจำตัวผู้เสียภาษี...."},domProps:{"value":(_vm.data_detail.tax_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_detail, "tax_id", $event.target.value)}}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.editConfigCompany}},[_c('i',{staticClass:"far fa-save"}),_vm._v(" บันทึกข้อมูล")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_settings_company__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__ = __webpack_require__(1110);

/* eslint-disable eqeqeq */




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      confirmDirty: false,
      head_menu: [{
        role_id: 1,
        role_name: 'ทั่วไป'
      }, {
        role_id: 2,
        role_name: 'สิทธิ์'
      }],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      },
      data_role: {
        role_id: null,
        role_name: null,
        role_code: null
      },
      data_all: [],
      role_code: '',
      role_name: '',
      role_list: []
    };
  },

  components: {
    CompanyView: __WEBPACK_IMPORTED_MODULE_1__components_settings_company__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'permission' });
  },

  methods: {
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.form.validateFieldsAndScroll(function (err, values) {
        if (!err) {
          if (_this.data_all.id != undefined) values.role_id = parseInt(_this.data_all.id);
          values.create_by = _this.$store.state.user.username;
          if (values.role_id != undefined) {
            // this.userUpdate(values)
            values.sub_permission = _this.data_all.menu_permission;
            _this.$store.commit('Loading');
            __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__["a" /* default */].roleUserUpdate({ data: values }, _this.header, function (result) {
              _this.$store.commit('Loading');
              if (result.data.success) {
                console.log(result.data);
                // this.$store.state.historyPage = 'role_menage'
                _this.$router.push({ name: 'role_menage_detail', params: { role_code: values.role_code } });
                _this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", null);
              } else {
                _this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ", null);
              }
            }, function (error) {
              _this.$store.commit('Loading');
              _this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ", error.message);
            });
          } else {

            values.sub_permission = _this.data_all.menu_permission;
            _this.$store.commit('Loading');
            __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__["a" /* default */].roleUserInsert({ data: values }, _this.header, function (result) {
              _this.$store.commit('Loading');
              if (result.data.success) {
                console.log(result.data);
                // this.$store.state.historyPage = 'role_menage'
                _this.$router.push({ name: 'role_menage_detail', params: { role_code: values.role_code } });
                _this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", null);
              } else {
                // this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ", null);
                _this.$notification['warning']({
                  message: 'บันทึกข้อมูลไม่สำเร็จ เนื่องจากรหัสสิทธิ์ผู้ใช้งานซ้ำ',
                  description: result.message
                });
              }
            }, function (error) {
              _this.$store.commit('Loading');
              _this.alert_msg("warning", "บันทึกข้อมูลไม่สำเร็จ", error.message);
            });

            // this.confirmData(values)
          }
        }
      });
    },
    onChange: function onChange(checked) {
      if (checked == 0) {
        return 1;
      }

      if (checked == 1) {
        return 0;
      }
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    checkdata: function checkdata() {
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data_all));
    },
    UpdateMenuRole: function UpdateMenuRole() {
      var _this2 = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].UpdateMisMenuRole(sessionStorage.Url, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, this.data_all, function (result) {
        _this2.$store.commit('Loading');
        if (result.response === 'success') {
          location.reload();
        } else {
          _this2.alert_msg('warning', 'ดึงข้อมูลไม่ได้', result.message);
        }
      }, function (error) {
        _this2.$store.commit('Loading');
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getMenuRole: function getMenuRole(val) {
      var _this3 = this;

      if (this.role_code != null && this.role_code != '') {
        __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__["a" /* default */].roleUserGetCode({ role_code: this.role_code }, this.header, function (result) {
          if (result.data.success) {
            _this3.data_all = result.data.result[0];
            _this3.role_code = result.data.result[0].role_code;
            _this3.role_name = result.data.result[0].role_name;
            _this3.role_list = result.data.result[0].menu_permission;
            _this3.form.setFieldsValue({ role_code: result.data.result[0].role_code, role_name: result.data.result[0].role_name });
          } else {
            _this3.alert_msg("warning", "ไม่สามารถดึงข้อมูลได้", null);
          }
        }, function (error) {
          _this3.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        });
      } else {

        __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__["a" /* default */].roleUserGet(this.header, function (result) {
          if (result.data.success) {
            _this3.data_role['menu_permission'] = result.data.menu_permission;
            _this3.data_all = _this3.data_role;
            _this3.role_code = '';
            _this3.role_name = '';
            _this3.role_list = result.data.menu_permission;
          } else {
            _this3.alert_msg("warning", "ไม่สามารถดึงข้อมูลได้", null);
          }
        }, function (error) {
          _this3.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        });
      }
    }
  },
  mounted: function mounted() {
    this.role_code = this.$route.params.role_code;
    this.getMenuRole(1);
    this.checkUser();
  }
});

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height': _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body"},[_c('h1',{staticStyle:{"font-weight":"bold"}},[_vm._v("จัดการสิทธิ์ผู้ใช้งาน")]),_vm._v(" "),_c('a-tabs',{attrs:{"type":"card","size":"large"}},_vm._l((_vm.head_menu),function(x){return _c('a-tab-pane',{key:x.role_id,attrs:{"tab":x.role_name}},[(x.role_name != 'สิทธิ์')?_c('div',{staticClass:"container-fluid"},[_c('a-col',{staticStyle:{"background-color":"#ffffff","padding":"10px"},attrs:{"span":16}},[_c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',_vm._b({},'a-form-item',_vm.formItemLayout,false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                  รหัสสิทธิ์ผู้ใช้งาน \n                  "),_c('a-tooltip',{attrs:{"title":"What do you want others to call you?"}},[_c('a-icon',{attrs:{"type":"question-circle-o"}})],1)],1),_vm._v(" "),_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                  'role_code',
                  {
                    rules: [{ required: true, message: 'กรุณากรอก รหัสสิทธิ์ผู้ใช้งาน', whitespace: true }],
                  } ]),expression:"[\n                  'role_code',\n                  {\n                    rules: [{ required: true, message: 'กรุณากรอก รหัสสิทธิ์ผู้ใช้งาน', whitespace: true }],\n                  },\n                ]"}],attrs:{"id":"role_code","maxLength":"30"}})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"ชื่อสิทธิ์ผู้ใช้"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                    'role_name',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณากรอกชื่อสิทธิ์ผู้ใช้',
                          whitespace: true
                        }
                      ]
                    }
                  ]),expression:"[\n                    'role_name',\n                    {\n                      rules: [\n                        {\n                          required: true,\n                          message: 'กรุณากรอกชื่อสิทธิ์ผู้ใช้',\n                          whitespace: true\n                        }\n                      ]\n                    }\n                  ]"}],attrs:{"id":"role_name","maxLength":"30"}})],1),_vm._v(" "),_c('a-form-item',_vm._b({},'a-form-item',_vm.tailFormItemLayout,false),[_c('a-button',{attrs:{"type":"primary","html-type":"submit"}},[_vm._v("\n                  บันทึก\n                ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(x.role_name == 'สิทธิ์')?_c('div',{staticClass:"container-fluid"},[_c('table',{staticClass:"table table-bordered",attrs:{"id":"sendMoney","colspan":"6"}},[_c('thead',[_c('tr',{staticClass:"text-center",staticStyle:{"background-color":"cornflowerblue"}},[_c('th',[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("ปิด-เปิด")])])]),_vm._v(" "),_vm._l((_vm.data_all.menu_permission),function(d,i){return _c('tbody',{key:i},[_c('tr',{staticStyle:{"background-color":"aliceblue"}},[_c('th',[_vm._v("กลุ่มเมนู: "+_vm._s(d.head_menu_name))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('a-switch',{attrs:{"defaultChecked":"","checked":d.is_read == 1 ? true : false},on:{"change":function($event){d.is_read = _vm.onChange(d.is_read)}}},[_c('a-icon',{attrs:{"slot":"checkedChildren","type":"check"},slot:"checkedChildren"}),_vm._v(" "),_c('a-icon',{attrs:{"slot":"unCheckedChildren","type":"close"},slot:"unCheckedChildren"})],1)],1)]),_vm._v(" "),_vm._l((d.sub_menu),function(s,y){return _c('tr',{key:y},[_c('td',[_vm._v("- "+_vm._s(s.menu_name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a-switch',{attrs:{"defaultChecked":"","checked":s.is_read == 1 ? true : false},on:{"change":function($event){s.is_read = _vm.onChange(s.is_read)}}},[_c('a-icon',{attrs:{"slot":"checkedChildren","type":"check"},slot:"checkedChildren"}),_vm._v(" "),_c('a-icon',{attrs:{"slot":"unCheckedChildren","type":"close"},slot:"unCheckedChildren"})],1)],1)])})],2)})],2)]):_vm._e()])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.2ffd3e14cf84f0cca667.js